import i18next from 'i18next'

export const essentialDataSource = () => [
    {key: 'name', label: i18next.t('Cookies.descriptions.name'), value: i18next.t('Cookies.descriptions.cookie')},
    {key: 'provider', label: i18next.t('Cookies.descriptions.provider'), value: i18next.t('Cookies.descriptions.ownerOfSite')},
    {
        key: 'saves_preferences',
        label: i18next.t('Cookies.descriptions.saveVisitorsPreferences'),
        value: i18next.t('Cookies.descriptions.cookieByGoogleAdvanced')
    },
    {key: 'cookie_name', label: i18next.t('Cookies.descriptions.cookieName'), value: 'cookie'},
    {key: 'cookie_expiry', label: i18next.t('Cookies.descriptions.cookieExpiry'), value: i18next.t('Cookies.descriptions.year')}
]

export const statisticsDataSource = () => [
    {key: 'name', label: i18next.t('Cookies.descriptions.name'), value: i18next.t('Cookies.descriptions.googleTagManager')},
    {key: 'provider', label: i18next.t('Cookies.descriptions.provider'), value: i18next.t('Cookies.descriptions.googleLLC')},
    {
        key: 'purpose',
        label: i18next.t('Cookies.descriptions.purpose'),
        value: i18next.t('Cookies.descriptions.cookieByGoogleAdvanced')
    },
    {key: 'privacy_policy', label: i18next.t('Cookies.descriptions.privacyPolicy'), value: 'https://policies.google.com/privacy?hl=en'},
    {key: 'cookie_name', label: i18next.t('Cookies.descriptions.cookieName'), value: '_ga,_gat,_gid'},
    {key: 'cookie_expiry', label: i18next.t('Cookies.descriptions.cookieExpiry'), value: i18next.t('Cookies.descriptions.twoYears')}
]
